import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store/reducers';

export const selectWebsocketStatus = (state: RootState) => state.websocketStatus;

export const selectBuildInfo = (state: RootState) => state.websocketStatus?.buildInfo;

const selectSystemServiceStatuses = (state: RootState) => state.websocketStatus?.services;

export const selectFailedServices = createSelector(
    selectWebsocketStatus,
    selectSystemServiceStatuses,
    (status, systemServicesStatus) => {
        if (status.isConnected) {
            return [];
        }
        const serviceNames = Object.keys(systemServicesStatus || {});
        return serviceNames.filter(
            (serviceName) => systemServicesStatus && systemServicesStatus[serviceName] !== 'RUNNING'
        );
    }
);

export const selectIsAllServicesFailed = createSelector(
    selectWebsocketStatus,
    selectFailedServices,
    selectSystemServiceStatuses,
    (status, failedServices, systemServicesStatus) => {
        if (status.isConnected) {
            return false;
        }
        const serviceNames = Object.keys(systemServicesStatus || {});
        return serviceNames.length === failedServices.length;
    }
);

export const selectIsInMaintenance = createSelector(
    [selectWebsocketStatus],
    (status) => status?.maintenanceStarted
);

export const selectIsSuspended = createSelector(
    [selectWebsocketStatus],
    (status) => status?.suspended
);
